import React from 'react'
import PropTypes from 'prop-types'
import classes from 'classnames'

import { toUpper } from 'lodash'

const Label = ({ text, children, intent }) => (
    <span className={ classes('label', `label-${intent}`) }>
        { toUpper(text) }
        { children }
    </span>
)

Label.propTypes = {
    text   : PropTypes.string,
    intent : PropTypes.string
}

export default Label
